import {ObjectId} from "mongodb";
import {defaultOutboxFieldNames, OutboxFieldNames} from "@app/core-app/app/domain/notion/configurations/outbox";
import {InboxFieldNames} from "@app/core-app/app/domain/notion/inbox";


export type EmailVerificationStatus = {
    email: string
}

export type DomainVerification = {
    domain: string
    pubKey: string
    selector: string
}

export type NotionConnectionStatus = {
    accessToken: string
    workspaceName: string
    workspaceIcon: string
    workspaceId: string
}

export type DataExtractionProperty = {
    propertyId: string
    propertyName: string
    propertyDescription: string
}

export type DataExtractionConfig = {
    properties: DataExtractionProperty[]
    enabled: boolean

}

export type DefaultPropertyConfig = {
    name: string
    type: string
    defaultValue: any
}

export type DefaultPropertiesConfig = {
    properties: DefaultPropertyConfig[]
}

export const DEFAULT_DATA_EXTRACTION_CONFIG = {enabled: false, properties: []}
export const DEFAULT_INHERIT_PARENT_TYPE = "last_reply"
export const DEFAULT_PROPERTIES_CONFIG = {properties: []}

export type InheritPropertiesConfig = {
    name: string
}

export type InboxDbConfig = {
    saveAs: "plain_text" | "embed" | undefined | null
    dataExtractionConfig?: DataExtractionConfig | undefined | null
    inheritParentType?: "last_reply" | "first_reply" | undefined | null
    inheritParentProperties?: InheritPropertiesConfig[] | undefined | null
    customFieldNames?: InboxFieldNames | undefined | null
    defaultPropertiesConfig?: DefaultPropertiesConfig | undefined | null

}

export type OutboxRenderPreferences = {
    // Render Engine Configuration
    renderEngine?: string | undefined | null

    // General Configuration
    showTitle: boolean
    bgColor: string
    verticalPadding: string
    maxWidth: string
    centerContent: boolean
    hideUnsupported: boolean

    // Font Configuration
    fontSize: string
    fontFamily: string
    fontColor: string
    lineHeight: string


    // Image Configuration
    downloadImages: boolean
    imagesWidth: "full_page" | "image_width",
    imagesPositioning: "left" | "center",
}

export const DEFAULT_RENDER_CONFIG: OutboxRenderPreferences = {
  renderEngine: "mjml",

  showTitle: true,
  bgColor: "#FFFFFF",
  verticalPadding: "2px",
  maxWidth: "600px",
  centerContent: true,
  hideUnsupported: true,

  // Font Configuration
  fontSize: "15px",
  fontFamily: "Arial",
  fontColor: "#37352f",
  lineHeight: "1.5",


  // Images
  downloadImages: true,
  imagesPositioning: "center",
  imagesWidth: "full_page",
}

export const DEFAULT_OUTBOX_CONFIG: OutboxDbConfig = {
  autoSend: false,
  renderConfiguration: DEFAULT_RENDER_CONFIG,
  customFieldNames: defaultOutboxFieldNames
}


export type OutboxDbConfig = {
    autoSend: boolean | undefined | null
    renderConfiguration: OutboxRenderPreferences | undefined | null
    fromEmailAddress?: string | undefined | null
    fromSenderName?: string | undefined | null
    replyToEmailAddress?: string | undefined | null
    customFieldNames?: OutboxFieldNames | undefined | null
    recipientsDatabaseId?: string | undefined | null
}


export type DbConfig = {
    databaseId: string,
    key: string | undefined | null,
    inbox: InboxDbConfig | null | undefined
    outbox: OutboxDbConfig | null | undefined
}

export type ProfileUsageData = {

    sentEmails?: number | undefined

    savedEmails?: number | undefined

    autosendEnabledCount?: number | undefined

    addressesInUse?: number | undefined

    addresses?: string[] | undefined

}

export type BillingInfo = {
    subscriptionId: string

}

export type SenderReputation = {
    bounceRate: number;     // Percentage of bounced emails
    complaintRate: number;  // Percentage of complaints
    totalSentEmails: number;
};

export type SuspensionReason = "hardLimitSenderSafety" | "savedLimit" | "sentLimit" | "bounceRate" | "complaintRate"


export type Profile = {
    _id: ObjectId
    email: string
    suspended: boolean | undefined | null
    suspendedReason?: SuspensionReason | undefined | null
    premium: boolean | undefined | null
    emailVerification: EmailVerificationStatus | null | undefined
    domainVerification: DomainVerification | null | undefined
    notionConnection: NotionConnectionStatus | null | undefined
    dbConfigurations: DbConfig[] | null | undefined
    billingInfo: BillingInfo | undefined | null
    reputation: SenderReputation | undefined | null

    customSendingLimit?: number | undefined | null

}


